import { SearchOutlined } from '@ant-design/icons';
import { Button, Form, FormInstance, Input, Space } from 'antd';

const requiredRules = [
  { required: true, message: 'Поле обязательно для заполнения' },
];

type StringFilterFormProps = {
  form: FormInstance<{ value: string }>;
  value?: string;
  placeholder?: string;
  onSubmit: (value: string) => void;
  onReset: () => void;
};
// eslint-disable-next-line mobx/missing-observer
export const StringFilterForm = ({
  form,
  value,
  placeholder,
  onSubmit,
  onReset,
}: StringFilterFormProps) => {
  const handleSubmit = ({ value }: { value: string }) => {
    onSubmit(value);
  };

  const handleReset = () => {
    onReset();
  };

  return (
    <div className="ag-filter">
      <Form
        layout="vertical"
        className="ag-filter-wrapper ag-focus-managed"
        form={form}
        fields={[{ name: 'value', value }]}
        onFinish={handleSubmit}
        onReset={handleReset}
      >
        <div className="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
          <div
            className="ag-filter-body"
            role="presentation"
            aria-hidden="false"
          >
            <div
              role="presentation"
              className="ag-labeled ag-label-align-left ag-number-field ag-input-field ag-filter-from ag-filter-filter"
              aria-hidden="false"
            >
              <div
                className="ag-wrapper ag-input-wrapper ag-number-field-input-wrapper"
                role="presentation"
              >
                <Form.Item name="value" rules={requiredRules} noStyle>
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder={placeholder || 'Поиск...'}
                  />
                </Form.Item>
              </div>
            </div>
          </div>

          <Space direction="vertical" style={{ width: '100%', marginTop: 8 }}>
            <Button type="primary" htmlType="submit" block>
              Найти
            </Button>
            <Button htmlType="reset" block>
              Сбросить
            </Button>
          </Space>
        </div>
      </Form>
    </div>
  );
};
